import React, { Component }     from "react";
import { FontAwesomeIcon }      from '@fortawesome/react-fontawesome'
import { Button, FormControl, Modal, ListGroup, ListGroupItem } from "react-bootstrap";
import uniqueId                 from 'lodash/uniqueId';
import FreeFormTextArea         from "../../components/form/FreeFormTextArea";
import { TS_LU, TS_ASP }        from "../../utils/StaticIds";
import { invokeSetProgramSummary, invokeGetProgramSummary } from "../../utils/AwsInvoke";
import "../../css/modal/ModalProgramSummary.css";

export default class ModalProgramSummary extends Component {

    constructor(props) {
        super(props);

        this.state = {
            program_id: null,
            error_msg:  "Loading data...",
            showModalSimple: false,
            programName: "",
            summary: "",
            price: 0,
            isPricedTemplate: false
        };
    }

    getAdminUserId = () => {
       var globalAdminUserId = localStorage.getItem('globalAdminUserId');
       return globalAdminUserId;
    }

    async componentDidMount() {
        try {
            var program_id         = this.props.program_id;
            var is_priced_template = this.props.isPricedTemplate;
            var program_name       = this.props.programName;
            var option             = "no";
            if(is_priced_template) option = "yes";

            this.setState({
                program_id: program_id,
                isPricedTemplate: is_priced_template,
                selectedOption: option,
                programName: program_name
            });
            const results = await invokeGetProgramSummary(program_id);

            if(results) {
                var summary = results.summary;
                var price   = results.price;

                if(summary == undefined) summary = "";
                if(price == undefined) price = 0;

                this.setState({
                    summary: summary,
                    price: price,
                    error_msg:  ""
                });
            }
        } catch (e) {
            this.setState({
                error_msg:  ""
            });
            alert(e);
        }
    }

    handleSubmit = async event => {
        var program_id         = this.state.program_id;
        var price              = this.state.price;
        var summary            = this.state.summary;
        var is_priced_template = this.state.isPricedTemplate;

        const results = await invokeSetProgramSummary(program_id, price, summary, is_priced_template);

        if(results) {
            // Close Modal //
            this.props.onHide();
            this.props.getProgramList("");
        } else
            this.setState({
                error_msg: "Ooops, looks like there was an error. Try again."
            })
    }

    handleNotesChange = (event) => {
        var summary = event.target.value;

        this.setState({
            summary: summary
        })
    }

    handlePriceChange = (event) => {
        var price = event.target.value;
        if(isNaN(price)) price = 0;

        this.setState({
            price: price
        })
    }

    handleOptionChange = (event) => {
        var option = event.target.value;
        var is_priced_template = false;

        if(option === "yes") is_priced_template = true;

        this.setState({
                selectedOption: option,
                isPricedTemplate: is_priced_template
                //exerciseSaved: true
        });

        /*setTimeout(
            function() {
                this.setState({exerciseSaved: false});
                console.log("fadeSaveLabel");
            }
            .bind(this), 2000
        );*/
    }

    render() {
        var summary = this.state.summary;
        var price   = this.state.price;
        var is_priced_template  = this.state.isPricedTemplate;
        var show_price_template = "";
        var radio_option        = this.state.selectedOption;
        var level               = 0;
        var globalAdminUserId = this.getAdminUserId()

        if(globalAdminUserId === TS_LU || globalAdminUserId === TS_ASP) {
            level = 5;
        }

        //current_notes = this.state.exerciseNotes; // use exerc notes, not free-form notes
        //var notes_lgth = Object.keys(current_notes).length;
        //if(notes_lgth <= 1)
        //    summary = "<p></p>"; // clear exerciseNotes state

        var price_per_template = <span>
                                    <div className="modalFormLabelBody">Price Per Template</div>
                                     <span className="modalProgramSummaryDollarAmnt">$ </span>
                                     <FormControl
                                         className         = "input-lg formModalSummaryTemplatePrice"
                                         style             = {{fontSize:"20px", border:"2px solid #ccc"}}
                                         type              = "text"
                                         value             = {price}
                                         autoFocus         = {true}
                                         onChange          = {this.handlePriceChange.bind(this)}
                                     />
                                     <br/><br/>
                                 </span>
        var price_template_component = <span>
                                           <span className="modalFormLabelBody">Is this a priced template?</span>
                                           <div>
                                                 <input type="radio"
                                                        value="no"
                                                        className="modalProgramSummaryRadioBtn_no"
                                                        checked={this.state.selectedOption === 'no'}
                                                        onChange={this.handleOptionChange} />
                                                    <span className="radioBtnProgramSummaryLabel">No</span>

                                                 <input type="radio"
                                                        value="yes"
                                                        className="modalProgramSummaryRadioBtn_yes"
                                                        checked={this.state.selectedOption === 'yes'}
                                                        onChange={this.handleOptionChange} />
                                                 <span className="radioBtnProgramSummaryLabel"> Yes</span>
                                             </div>
                                             <br/>
                                         </span>
        if(!is_priced_template || radio_option === "no" || level === 0)
            price_per_template = "";

        if(level === 0)
            price_template_component = "";

        var program_name = this.state.programName;
        return (
            <Modal
                    show      = {this.props.show}
                    onHide    = {this.props.onHide}
                    className = "modalBasics"
              >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title" className="fontSize26px">
                        <span className = "glyphicon glyphicon-list-alt glyphiconProgramSummaryModalTitle" />
                        <span className="modalBasicsTitle">
                             {program_name} Summary
                        </span>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <span className="modalBasicsBody">
                            { price_template_component }
                            { price_per_template }
                            <span className="modalFormLabelBody">Summary</span>
                            <textarea value     = {summary}
                                      className = "modalProgramSummaryTextarea"
                                      onChange  = {this.handleNotesChange} />
                            { /*}<FreeFormTextArea handleNotesChange = {this.handleNotesChange.bind(this)}
                                              height            = {150}
                                              notes             = {current_notes}/>*/ }

                          { this.state.error_msg }
                          <br/>
                    </span>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="modalBasicsBtnClose" onClick={this.props.onHide}>Cancel</Button>
                    <span className="modalBasicsFooterXPosSpacer"/>
                    <Button className="modalSummarySubmitBtnOk" onClick={() => this.handleSubmit()}>Submit</Button>
                </Modal.Footer>
              </Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalProgramSummary.js